import { API_URL } from "../../../../../constants";
import * as httpNetworking from "../../../../../httpNetworking";

const GET_TELEPORT_STATUS_URL = API_URL + "/saas/multi-tenancy/deployment/teleport";
const GET_TELEPORT_STATUS_API_VERSION = 0;

type TTeleportStatus = {
    status: "pending" | "target-assigned" | "data-migrated" | "finished";
};

export async function getTeleportStatus(params: { deploymentType: "production" | "development" }) {
    const options: httpNetworking.GETRequestConfig = {
        timeout: 10000,
        params
    };

    const result = await httpNetworking.simpleGETRequest(
        GET_TELEPORT_STATUS_URL,
        options,
        GET_TELEPORT_STATUS_API_VERSION
    );
    return result.data as TTeleportStatus;
}
